<template>
  <!--  v-rightMenu鼠标右键菜单自定义模板-->
  <el-table
    v-loading="loading"
    class="sp-edit"
    v-bind="$attrs"
    v-on="$listeners"
    ref='spTable'
    border
    row-key='uid'
    :data="parentTableData"
    @cell-click="toEdit"
    @row-click="clickFn"
    @row-dblclick="dblclickFn"
    @header-dragend="changeHeaderWidth"
    v-rightMenu="menudata"
  >
    <slot>
    </slot>
  </el-table>
</template>
<script>
  import Sortable from 'sortablejs';
  import $ from 'jquery';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];

  const _ = require('lodash');

  export default {
    name: 'spTable',
    props: {
      parentCol: {
        type: Array,
        request: true,
      },
      // 是否支持拖拽
      dragDrop: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      // 列表数据
      parentTableData: {
        type: Array,
        request: true,
      },
      // 是否出现选择框
      isCheckbox: {
        type: Boolean,
        default: false,
      },
      // width: Array
      // 是否使用展开行
      isExpand: {
        type: Boolean,
        default: false,
      },
      // 自定义合计逻辑
      getSummaries: Function,
      // 第几个节点
      keyDom: {
        type: Number,
        default: 0,
      },
      // summaryData: Array
    },
    data() {
      return {
        menudata: {
          // 菜单box的样式   Menu box style
          boxStyle: 'width:150px;background:#f55;z-index:999',
          // 菜单选项的样式 Style of menu options
          optionStyle: 'color:#fff;line-height:30px;font-size:15px;',
          menus: [
            {
              content: '导出Excel',
              callback: 'exportExcel',
              style: 'border-bottom:1px solid #fff;background:#333;line-height:30px;',
              iconStyle: 'width:20px;height:20px;',
              iconPosition: 'left',
            },
            {
              content: '保存数据字典',
              callback: 'saveDictionary',
              style: 'border-bottom:1px solid #fff;background:#333;line-height:30px;',
              iconStyle: 'width:20px;height:20px;',
              iconPosition: 'left',
            },
          ],
        },
        nweWidth: 0,
        width: [55, 100, 150, 200, 250, 300, 200, 200, 200, 200, 200, 200, 200, 200, 200],
        loading: false,
        col: [],
        dropCol: [], // 拖动后的数据
        tableData: [],
        maxHeight: 200,
        contextMenuTarget: null,
        contextMenuVisible: false,
        exhibitionFont: [], // 该列数据是否可以被查看
        expandRowKeys: [],
        refresh: true,
        bindKeyEvent: false,
        keyEvent: event => {
          const current = $('.cellFocus');
          const currentClass = current.attr('class');
          switch (event.keyCode) {
            case 37: // 左键
              if (currentClass.indexOf('el-table') !== -1) {
                if (current.prev().length === 0) return;
                current.prev().addClass('cellFocus cellActive');
                current.removeClass('cellFocus cellActive');
                current.prev().find('input').focus();
              }
              else {
                if (current.parent().prev().length === 0) return;
                current.parent().prev().addClass('cellFocus cellActive');
                current.removeClass('cellFocus cellActive');
                current.parent().prev().find('input').focus();
              }
              break;
            case 38: // 上键
              if (currentClass.indexOf('el-table') !== -1) {
                if (current.parent().prev().length === 0) return;
                current.removeClass('cellFocus cellActive');
                current.parent().prev().find('td').eq(current.index()).addClass('cellFocus cellActive');
                current.parent().prev().find('td').eq(current.index()).find('input').focus();
              }
              else {
                if (current.parent().parent().prev().length === 0) return;
                current.removeClass('cellActive cellActive');
                current.parent().parent().prev().find('td').eq(current.parent().index()).addClass('cellFocus cellActive');
                current.parent().parent().prev().find('td').eq(current.parent().index()).find('input').focus();
              }
              break;
            case 39: // 右键
              if (currentClass.indexOf('el-table') !== -1) {
                if (current.next().length === 0) return;
                current.next().addClass('cellFocus cellActive');
                current.removeClass('cellFocus cellActive');
                current.next().find('input').focus();
              }
              else {
                if (current.parent().next().length === 0) return;
                current.parent().next().addClass('cellFocus cellActive');
                current.removeClass('cellFocus cellActive');
                current.parent().next().find('input').focus();
              }
              break;
            case 40: // 下键
              if (currentClass.indexOf('el-table') !== -1) {
                current.removeClass('cellFocus cellActive');
                if (current.parent().next().length > 0) {
                  current.parent().next().find('td').eq(current.index()).addClass('cellFocus cellActive');
                  current.parent().next().find('td').eq(current.index()).find('input').focus();
                }
                else {
                  this.$emit('addNewData', () => {
                    current.parent().next().find('td').eq(current.index()).addClass('cellFocus cellActive');
                    current.parent().next().find('td').eq(current.index()).find('input').focus();
                  });
                }
              }
              else {
                current.removeClass('cellFocus cellActive');
                current.parent().parent().next().find('td').eq(current.parent().index()).addClass('cellFocus cellActive');
                current.parent().parent().next().find('td').eq(current.parent().index()).find('input').focus();
              }
              break;
            case 13:
              // current.addClass('cellActive');
              current.find('input').focus();
              break;
            case 9:
              if (currentClass.indexOf('el-table') !== -1) {
                if (current.next().length !== 0) {
                  current.next().addClass('cellFocus cellActive');
                  current.removeClass('cellFocus cellActive');
                  current.next().find('input').focus();
                } else {
                  if (current.parent().next().length > 0) {
                    current.parent().next().find('td').eq(1).addClass('cellFocus cellActive');
                    current.parent().next().find('td').eq(1).find('input').focus();
                  } else {
                    this.$emit('addNewData', () => {
                      current.parent().next().find('td').eq(1).addClass('cellFocus cellActive');
                      current.parent().next().find('td').eq(1).find('input').focus();
                    });
                  }
                }
              }
              else {
                if (current.parent().next().length === 0) return;
                current.parent().next().addClass('cellFocus cellActive');
                current.removeClass('cellFocus cellActive');
                current.parent().next().find('input').focus();
              }
              break;
          }
        },
      };
    },
    created() {
      this.initTable();
      let re = storage.$get({key: '$notifyShow'});
      !re || re === 'false' ? this.alertNotify() : '';
    },
    mounted() {
      this.unbindKeys();
      if (this.dragDrop) {
        this.columnDrop(this.keyDom);
        this.getTableWidth();
        this.$nextTick(() => {
          this.contextMenuTarget = this.$refs.spTable.$el;
        });
      }
    },
    methods: {
      alertNotify() {
        storage.$set({
          key: '$notifyShow',
          parameter: true,
        });
        this.$notify({
          title: '表格操作提示',
          message: '1、在数据上右键，则默认为复制了该单元格中内容。<br/>' +
          '2、在表头上右键，可以导出EXCEL报表。',
          duration: 0,
          dangerouslyUseHTMLString: true,
          position: 'bottom-left',
       /*   onClose: () => {   //注释取消后，新开tab会重新弹窗显示通知消息
            storage.$set({
              key: '$notifyShow',
              parameter: 'false',
            });
          }*/
        });
      },
      exportExcel() {
        const tHeader = [];
        const filterVal = [];
        const colType = [];
        const colWidth = [];
        this.parentCol.forEach(col => {
          tHeader.push(col.title);
          filterVal.push(col.field);
          colWidth.push(col.width);
          colType.push(col.fieldType);
        });
        this.tableData = _.cloneDeep(this.parentTableData);
        let list = JSON.parse(JSON.stringify(this.tableData));
        //将合计行添加到导出数据中
        if (this.$attrs['summary-data']) {
          let numData = this.$attrs['summary-data'][1];
          let countData = {};
          numData = numData.filter(v => v);
          this.$attrs['summary-data'][0].forEach((v, i) => {
            countData[v] = numData[i + 1];
          });
          filterVal.forEach((v, i) => {
            !countData[v] ? countData[v] = '' : '';
            i == 0 ? countData[v] = '合计' : '';
          });
          list.push(countData);
        }
        this.$utils.generateExcel({
          tHeader,
          list,
          filterVal,
          excelName: `${this.$route.meta.title}_${this.$utils.getTime2(new Date())}`,
          colWidth,
          colType
        });
      },
      async saveDictionary() {
        let code = this.col[0].code;
        this.$services.postParams({
          type: 'DICTIONSAY',
          url: 'getDataDictId',
          cache: true,
          params: code,
        }).then(dictionary => {
          let bean = dictionary.bean;
          let dataDictDetails = bean.dataDictDetails;
          dataDictDetails.forEach(itme => {
            itme.updateFlg = 'update';
            this.col.forEach(colItme => {
              if (itme.fieldName === colItme.fieldName) {
                itme.displayWidth = (colItme.width - (itme.displayWidth * 1.2) + itme.displayWidth).toFixed();
                itme.displayIndex = colItme.displayIndex;
              }
              delete itme.code;
            });
          });
          bean.dataDictDetails = dataDictDetails;
          bean.updateFlg = 'update';
          this.$services.post({
            type: 'ERP',
            url: 'save',
            params: {
              data: JSON.stringify(bean)
            },
          }).then(res => {
            if (res.code === '000') {
              this.$message({
                message: '保存成功',
                type: 'success',
              });
            }
          });
        });
        // this.$emit('saveDictionary');
      },
      initTable() {

        this.tableData = _.cloneDeep(this.parentTableData);
        this.col = _.cloneDeep(this.parentCol);
        this.col.forEach((el, elKey) => {
          if (el.isHide) {
            this.exhibitionFont[elKey] = true;
          }
          else {
            this.exhibitionFont[elKey] = undefined;
          }
        });
        this.dropCol = _.cloneDeep(this.col);
      },
      clickFn(row) {
        this.$refs.spTable.clearSelection();
        this.$refs.spTable.toggleRowSelection(row);
      },
      dblclickFn(row) {
        this.$refs.spTable.clearSelection();
        this.$refs.spTable.toggleRowSelection(row);
        this.$emit('getDetail');
      },
      // 行拖拽
      rowDrop() {
        // const tbody = document.querySelector('.el-table__body-wrapper tbody');
        // Sortable.create(tbody, {
        //   animation: 180,
        //   onChoose: () => {
        //     this.expandRowKeys = [];
        //   },
        //   onEnd: ({ newIndex, oldIndex }) => {
        //     const currRow = this.tableData.splice(oldIndex, 1)[0];
        //     this.tableData.splice(newIndex, 0, currRow);
        //     this.$emit('update:parentTableData', this.tableData);
        //     this.$nextTick(() => {
        //       this.$forceUpdate();
        //     });
        //   },
        // });
      },
      // 列拖拽
      columnDrop(key) {
        let wrapperTr = document.querySelectorAll('.el-table__header-wrapper tr');
        //key=-1时，为gridDialog弹出框内的table，一般是最后一个？
        key > -1 ? wrapperTr = wrapperTr[key] : wrapperTr = wrapperTr[wrapperTr.length - 1];
        new Sortable.create(wrapperTr, {
          filter: '.el-table-column--selection, .el-table__expand-column, .index',
          animation: 180,
          onMove: (evt, originalEvent) => {
            if (originalEvent.target.querySelector('el-table-column--selection')
              || originalEvent.target.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.className.indexOf('el-checkbox__input') !== -1
              || originalEvent.target.parentNode.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.parentNode.parentNode.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.parentNode.className.indexOf('el-checkbox__input') !== -1) {
              return false;
            }
            if (originalEvent.target.querySelector('index')
              || originalEvent.target.className.indexOf('index') !== -1
              || originalEvent.target.className.indexOf('index') !== -1
              || originalEvent.target.parentNode.className.indexOf('index') !== -1
              || originalEvent.target.parentNode.parentNode.className.indexOf('index') !== -1
              || originalEvent.target.parentNode.className.indexOf('index') !== -1) {
              return false;
            }
          },
          onEnd: ({newIndex, oldIndex}) => {
            newIndex--;
            oldIndex--;
            const adjust = document.querySelector('.el-table-column--selection');
            if (adjust) {
              newIndex--;
              oldIndex--;
            }
            if (newIndex === oldIndex) {
              setTimeout(() => {
                this.col[oldIndex].width = this.nweWidth;
              }, 300);
              return;
            }
            this.loading = true;
            const oldData = this.col[oldIndex];
            this.col.splice(oldIndex, 1);
            this.col.splice(newIndex, 0, oldData);
            this.$emit('update:parentCol', []);
            this.$nextTick(() => {
              this.$emit('update:parentCol', this.col);
              setTimeout(() => {
                this.loading = false;
              }, 500);
            });
          },
        });
      },
      changeHeaderWidth(newWidth, oldWidth, column, event) {
        this.nweWidth = newWidth;
      },
      // 判断是否可以移动列
      isMoveColumn(event) {
        // 判断table的selection是否还是在第一个位置如果不再则撤销改次移动
        let expandIndex = true;
        let selectionIndex = true;
        if (this.isExpand) {
          expandIndex = event.from.children[Number(this.isExpand) - 1].className.indexOf('el-table__expand-column');
        }
        if (this.isCheckbox) {
          selectionIndex = event.from.children[Number(this.isExpand) + Number(this.isCheckbox) - 1].className.indexOf('el-table-column--selection');
        }
        return selectionIndex !== -1 && expandIndex !== -1;
      },
      // 获取table表每个表头的宽度
      getTableWidth() {
        const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
        let widthCol = [];
        for (let i = 0; i < wrapperTr.children.length; i++) {
          widthCol.push(wrapperTr.children[i].offsetWidth);
        }
        this.$emit('getTableWidth', widthCol);
      },
      // 导入事件触发
      importEven() {
        this.contextMenuVisible = false;
        this.$emit('importEven');
      },
      // 导出事件触发
      exportEven() {
        this.contextMenuVisible = false;
        this.$emit('exportEven');
      },
      // 该行数据不显示
      isHideEven(itme, index, key) {
        this.exhibitionFont.splice(index, 1, false);
        this.$emit('isHideEven', {itme, index, key});
      },
      // 该行数据显示
      noHideEven(itme, index, key) {
        this.exhibitionFont.splice(index, 1, true);
        this.$emit('noHideEven', {itme, index, key});
      },
      // 拖拽后修正文字查看问题
      columnDropFontEven(oldIndexKey, newIndexKey) {
        let oldData = this.exhibitionFont[oldIndexKey];
        this.exhibitionFont.splice(oldIndexKey, 1);
        this.exhibitionFont.splice(newIndexKey, 0, oldData);
      },
      toEdit(row, column, cell, event) {
        if (!this.isEdit) return;
        this.unbindKeys();
        this.bindKey();
        const currentDom = $(event.target);
        const className = currentDom.attr('class');
        // debugger
        if (currentDom[0] && currentDom[0].children[0] && (currentDom[0].children[0].className.indexOf('el-checkbox') > -1) && (currentDom[0].children[0].className.indexOf('is-disabled') > -1)) return
        if (currentDom[0].className == 'el-checkbox__inner') return
        if ((currentDom[0] && currentDom[0].tagName === 'INPUT') || (className && className.indexOf('cell') > -1)) return;
        $('.sp-edit tr td').removeClass('cellFocus cellActive');
        $('.sp-edit tr td div').removeClass('cellFocus cellActive');
        if (className && className.indexOf('el-table') !== -1) {
          currentDom.addClass('cellActive cellFocus');
          currentDom.find('input').focus();
          return false;
        }
        if (className && className.indexOf('cell') !== -1) {
          currentDom.parent().classList.addClass('cellFocus cellActive');
          return false;
        }
        let currentChildrenClass = ''
        if (currentDom && currentDom[0] && currentDom[0].children && currentDom[0].children[0]) {
          currentChildrenClass = currentDom[0].children[0].getAttribute('class')
        }
        if ((currentChildrenClass && currentChildrenClass.indexOf('checkbox') !== -1) || (currentChildrenClass && currentChildrenClass.indexOf('is-disabled') !== -1)) {
          let index = this.parentTableData.findIndex(v => v.uid == row.uid);
          let datalist = this.parentTableData;
          datalist[index][column.property] ? datalist[index][column.property] = false : datalist[index][column.property] = true;
          this.$emit('update:parentTableData', datalist);
        }
        currentDom.parent().parent().addClass('cellFocus cellActive');
        currentDom.prev().find('input').focus();
      },
      unbindKeys() {
        $(document).unbind('keydown');
      },
      bindKey() {
        $(document).keydown(event => {
          if (event.keyCode === 9) {
            event.preventDefault();
            this.keyEvent(event)
          } else {
            this.keyEvent(event)
          }
        })
      },
      initSelect(selectList) {
        this.$nextTick(() => {
          if (selectList) {
            selectList.forEach(row => {
              this.$refs.spTable.toggleRowSelection(row);
            });
          }
          else {
            this.$refs.spTable.clearSelection();
          }
        });
      },
    },
    watch: {
      parentCol(v) {
        if (this.col.length === 0 && v.length !== 0) {
          this.initTable();
        }
      },
      /*  parentTableData(v) {
          if (!this.$attrs.tableUID) return;
          if (v.length === 0) {
            $('.edit .' + this.$attrs.tableUID + ' .el-table__body-wrapper').css({"cssText": "height:calc(100% - 40px) !important"});
          }
          else {
            $('.edit .' + this.$attrs.tableUID + ' .el-table__body-wrapper').css({"cssText": "height:calc(100% - 60px) !important"});
          }
        }*/
    }
  };
</script>
<style lang="scss">
  .sp-edit {
    //滚动条表头补充宽度
    .gutter {
      width: 8px !important;
      display: block !important;
      border-color: transparent !important;
    }
    .auto-input {
      display: none;
    }
    /*    max-height: 100%;
        display: flex;
        flex: 1;
        flex-direction: column;
        height: auto!important;*/

    .el-table__body {
      tr {
        &:last-child {
          .cellFocus {
            border-bottom: 2px solid blue !important;
            .span {
              /*background: #eaeaea;*/
            }
          }
        }
      }
    }

    .span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .cellFocus {
      border-bottom: 1px solid #409EFF !important;
    }

    .cellActive {
      .auto-input {
        display: block;
      }

      .auto-input + .span {
        display: none;
      }
    }
  }
</style>
